class Subject {
  protected static observers: Function[] = [];

  public static subscribe(fn: Function) {
    this.observers.push(fn);

    return () => this.unsubscribe(fn);
  }

  protected static fire(data: object) {
    this.observers.forEach((fn: Function) => {
      fn(data);
    });
  }

  protected static unsubscribe(fnr: Function) {
    this.observers = this.observers.filter(fn => fn !== fnr);
  }
}

export { Subject };
